const {
    OpulentThemeStyles,
    OpulentThemeScripts
} = window;
class QuickView {
    constructor() {
        this.modal = new OpulentTheme.Modal, this.isOpen = !1, addEventDelegate({
            selector: ".m-product-quickview-button",
            handler: (e, t) => {
                e.preventDefault(), this.target = t, this.toggleLoading(this.target, !0);
                const i = t.dataset.productHandle;
                i && this.fetchHtml(i)
            }
        }), window.OpulentEvents.subscribe(OpulentTheme.pubSubEvents.cartUpdate, (() => {
            this.modal && OpulentTheme.ProductQuickView.close()
        }))
    }
    fetchHtml(e) {
        loadAssetsNew([OpulentThemeStyles.product, OpulentThemeStyles.productInventory], "quick-view-assets"), fetchSection("product-quickview", {
            url: `${window.OpulentSettings.base_url}products/${e}`
        }).then((e => {
            this.modalContent = e.querySelector(".m-product-quickview");
            const t = e.querySelector("product-model");
            this.mediaGallery = this.modalContent.querySelector("media-gallery"), loadAssetsNew([OpulentThemeScripts.productMedia, OpulentThemeScripts.variantsPicker, OpulentThemeScripts.productInventory], "variants-picker", (() => {
                const e = this.modalContent.dataset.colorScheme;
                
                // Create drawer container
                this.drawerWrapper = document.createElement('div');
                this.drawerWrapper.className = 'm-drawer__wrapper m:fixed m:inset-0 m:z-50';
                this.drawerWrapper.style.cssText = '--m-bg-opacity: 0.5; background-color: rgba(var(--color-foreground), var(--m-bg-opacity));';
                
                // Create drawer content
                this.drawerContent = document.createElement('div');
                this.drawerContent.className = `m-cart-drawer__inner m:flex m:flex-col m-gradient ${e}`;
                
                // Set styles based on device
                const isDesktop = window.matchMedia('(min-width: 768px)').matches;
                if (isDesktop) {
                    this.drawerContent.style.cssText = '--translate-x-desktop: 100%; transform: translateX(var(--translate-x-desktop)); transition: transform 0.3s ease-in-out; position: fixed; right: 0; top: 0; bottom: 0; height: 100%; width: 500px; max-width: 100%;';
                } else {
                    this.drawerContent.style.cssText = '--translate-y-mobile: 100%; transform: translateY(var(--translate-y-mobile)); transition: transform 0.3s ease-in-out;';
                }
                
                // Add content to drawer
                this.drawerContent.appendChild(this.modalContent);
                this.drawerWrapper.appendChild(this.drawerContent);
                document.body.appendChild(this.drawerWrapper);
                
                // Set up close button event
                const closeButton = this.drawerContent.querySelector('.m-drawer__close');
                if (closeButton) {
                    closeButton.addEventListener('click', () => this.close());
                }
                
                // Close on click outside
                this.drawerWrapper.addEventListener('click', (e) => {
                    if (e.target === this.drawerWrapper) this.close();
                });
                
                // Show drawer with animation
                requestAnimationFrame(() => {
                    if (isDesktop) {
                        this.drawerContent.style.setProperty('--translate-x-desktop', '0');
                    } else {
                        this.drawerContent.style.setProperty('--translate-y-mobile', '0');
                    }
                });
                
                // Add to cart button handler for form submission
                const addToCartBtn = this.modalContent.querySelector('.product-form__submit');
                if (addToCartBtn) {
                    addToCartBtn.addEventListener('click', () => {
                        // We'll let the form submit naturally but close the drawer after a delay
                        setTimeout(() => {
                            this.close();
                        }, 500);
                    });
                }
                
                document.documentElement.classList.add("prevent-scroll");
                this.toggleLoading(this.target, false);
                this.isOpen = true;
            })), t && loadAssetsNew([OpulentThemeScripts.productModel, "https://cdn.shopify.com/shopifycloud/model-viewer-ui/assets/v1.0/model-viewer-ui.css"], "product-model-assets")
        })).catch(console.error)
    }
    close(e) {
        if (!this.isOpen || !this.drawerContent) return;
        
        const isDesktop = window.matchMedia('(min-width: 768px)').matches;
        if (isDesktop) {
            this.drawerContent.style.setProperty('--translate-x-desktop', '100%');
        } else {
            this.drawerContent.style.setProperty('--translate-y-mobile', '100%');
        }
        
        setTimeout(() => {
            if (this.drawerWrapper && document.body.contains(this.drawerWrapper)) {
                document.body.removeChild(this.drawerWrapper);
            }
            document.documentElement.classList.remove("prevent-scroll");
        }, 300);
        
        this.isOpen = false;
    }
    toggleLoading(e, t) {
        t ? e.classList.add("m-spinner-loading") : e.classList.remove("m-spinner-loading")
    }
}
OpulentTheme.ProductQuickView = new QuickView;